import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  isShown: status => (status ? { flex: 1 } : { display: 'none' }),
});
